import { Routes } from '@angular/router';
import { ViewSharedPackComponent } from './features/pages/view-shared-pack/view-shared-pack.component';
import { DocumentReviewedAuthentication } from './features/auth/components/document-reviewed.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },

  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'homes',
    component: DocumentReviewedAuthentication,
  },
  {
    path: 'packs/share/:token/:accessToken',
    component: ViewSharedPackComponent,
  },
  {
    path: 'packs/share/:token',
    component: ViewSharedPackComponent,
  },

  {
    path: '',
    canActivate: [authGuard()],
    loadChildren: () =>
      import('./features/pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: '**',
    redirectTo: '/auth/session-expired/:state',
  },
];
